// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"657a5cba","509":"faaad6c8"}[chunkId] + ".chunk.js";
};